import type {FilterFindManyIntegrationMessageInput} from "../../Queries";

/**
 * Restricts a message filter to a set of integration instances.
 *
 * The server exposes no `in` operator for instanceId - FilterFindManyIntegrationMessageOperatorsInput
 * only covers _id, lockedId, messageFailed and refId - so the set is expressed as an OR of equalities.
 *
 * Callers must not pass an empty instanceIds array: "no instances" means "no messages", which an
 * empty OR cannot express. Pages resolving a scope render an empty state instead of querying.
 */
export const scopeMessagesFilter = (
   rangeFilter: FilterFindManyIntegrationMessageInput | undefined,
   instanceIds: string[] | undefined
): FilterFindManyIntegrationMessageInput => {
   const filter = rangeFilter || {};
   if (!instanceIds) {
      return filter;
   }
   if (instanceIds.length === 0) {
      throw new Error('scopeMessagesFilter requires at least one instance id');
   }
   const scope: FilterFindManyIntegrationMessageInput = {
      OR: instanceIds.map(instanceId => ({instanceId}))
   };
   // RangeList hands over {} when nothing is selected - an AND against it would be noise.
   return Object.keys(filter).length === 0 ? scope : {AND: [filter, scope]};
}
